import { AUTH_URL } from "../../infra/data/env";

/* eslint-disable no-unused-vars */
export enum SistemaList {
    auth = 1,
    admin = 2,
    panels = 3,
    push = 4,
    carteira = 5,
    coopercred = 6
}

/* export enum SistemaRouteList{
    auth="http://localhost:5171/",
    //auth="https://brave-grass-0693e180f.4.azurestaticapps.net/",
} */

export function GetAuthRoute(): string {
    return AUTH_URL
}